import axios from 'axios'
export default {
    index(search, paginacion) {
        var url = `/productos/p?q=${search}&page=${paginacion.page}&page_size=${paginacion.rowsPerPage}`;
        return axios.get(url)
    },
    indexHistorial(id_producto, paginacion) {
        var url = `/productos/historial?id=${id_producto}&page=${paginacion.page}&page_size=${paginacion.rowsPerPage}`;
        return axios.get(url)
    },
    indexInventario(id_producto, paginacion) {
        var url = `/productos/inventario/${id_producto}/movimientos?page=${paginacion.page}&page_size=${paginacion.rowsPerPage}`;
        return axios.get(url)
    },
    indexCategorias(nombreCategoria, global = false, uso = null) {
        if (!nombreCategoria) {
            nombreCategoria = 'CATEGORIA';
        }

        let url = `/categorias/categorias?name=${encodeURIComponent(nombreCategoria)}`;
        console.log(global);

        // Solo agregar global si es true
        if (global) {
            url += `&global=true`;
        }
        if (uso) {
            url += `&uso=${uso}`;
        }

        return axios.get(url);
    },
    delete(id) {
        var url = `/productos/productos/${id}`;
        return axios.delete(url)
    },

    fetchProductosPorCategoria(nombreCategoria, paginacion) {
        var url = `/productos/p?categoria=${nombreCategoria}&page=${paginacion.page}&page_size=${paginacion.rowsPerPage}`;
        return axios.get(url)
    },
    createCategoria(data) {
        var url = "/categorias/";
        return axios.post(url, data);
    },
    updateCategoria(id, data) {
        var url = `/categorias/${id}`;
        return axios.put(url, data);
    },
    patchCategoriaUso(id, uso) {
        return axios.patch(`/categorias/${id}`, { uso });
    },
    getSuggest(search, categorias = [], global = false) {
        var url = `/productos/suggest?q=${search}&categorias=${categorias}&global=${global}`;
        return axios.get(url);
    },
    getSuggestEmpresa(search, categorias = [], global = true) {
        var url = `/productos/suggest-empresa?q=${search}&categorias=${categorias}&global=${global}`;
        return axios.get(url);
    },


    fetchPedidoYa() {
        return axios.get(`/productos/p?masvendidos=true&py=true`)
    },
    fetchMasVendidos() {
        return axios.get(`/productos/p?masvendidos=true`)
    },
    fetchInventario(params, paginacion) {
        var param_url = ''
        if (params.length > 0) {

            param_url = '&'
            for (var i = 0; i < params.length; i++) {
                var value = params[i].value
                var key = params[i].key
                param_url = param_url.concat(key, '=', value, '&')
            }
        }

        // var url = `/productos/p?page=${paginacion.page}&page_size=${paginacion.rowsPerPage}${param_url}`;

        if (!params || params.length == 0) return axios.get(`/productos/inventario?inventario=true&page=${paginacion.page}&page_size=${paginacion.rowsPerPage}`)

        return axios.get(`/productos/inventario?${param_url}page=${paginacion.page}&page_size=${paginacion.rowsPerPage}`)
    },
    fetchSinInventario() {
        return axios.get(`/productos/p?inventario=false`)
    },
    updateInventario(producto) {
        return axios.patch(`/productos/inventario/${producto.id}/stock`, producto)
    },
    registrarProductoFraccionado(productoPadre, productoParaRegistrar) {
        var data = { parent_id: productoPadre.id, producto: productoParaRegistrar }
        return axios.post(`/productos/fraccionados`, data)
    },
    show(id, uuid_s = null) {
        let url = `/productos/p/${id}`;
        if (uuid_s) {
            url += `?uuid_s=${uuid_s}`;
        }
        return axios.get(url);
    },
    getPspList(search, uuid_s = null, page = 1, pageSize = 24, isBarcode = false) {
        const param = isBarcode ? 'barcode' : 'q';
        let url = `/productos/psp?${param}=${search}&page=${page}&page_size=${pageSize}`;
        if (uuid_s) url += `&uuid_s=${uuid_s}`;
        return axios.get(url);
    },
    buscarPspPorCodigo(endpoint, codigo) {
        // Match exacto (no icontains) para escanear en el POS. Reusa el
        // `endpoint` que ya trae el filtro de la pantalla (ej. es_vendible=true).
        const [base, query] = endpoint.split('?');
        const params = new URLSearchParams(query || '');
        params.set('codigo', codigo);
        return axios.get(`${base}/buscar-por-codigo?${params}`);
    },
    showPsp(id, uuid_s = null) {
        let url = `/productos/psp/${id}`;
        if (uuid_s) {
            url += `?uuid_s=${uuid_s}`;
        }
        return axios.get(url)
    },
    show_empresa(id) {
        return axios.get(`/productos/productos/${id}`)
    },
    showProductosFraccionados(id) {
        return axios.get(`/productos/fraccionados/${id}`)
    },
    update(producto) {
        const params = {};
        if (producto.uuid_s) {
            params.uuid_s = producto.uuid_s;
        }
        return axios.put(`/productos/p/${producto.id}`, producto, { params });
    },
    updateProductoEmpresa(producto) {
        return axios.put(`/productos/productos/${producto.id}`, producto)
    },
    registrarSimple(data) {
        return axios.post(`/productos/p`, data)
    },
    anular(id, motivoAnulacion) {
        return axios.put(`comprobantes/anulados/${id}`, {
            motivoAnulacion: motivoAnulacion,
        });
    },
    actualizarPrecioSucursal(id, precioVenta) {
        return axios.put(`productos/producto-sucursal/${id}/actualizar-precio-venta`, {
            precio_venta: precioVenta,
        });
    },
    patchPspPrecio(id, { precio_venta, precio_costo, ganancia }) {
        return axios.patch(`/productos/psp/${id}/precio`, { precio_venta, precio_costo, ganancia });
    },
    patchPspContabilidad(id, { rubro_venta_id, rubro_compra_id }) {
        return axios.patch(`/productos/psp/${id}/contabilidad`, { rubro_venta_id, rubro_compra_id });
    },
    patchPspStock(id, payload) {
        return axios.patch(`/productos/psp/${id}/stock`, payload);
    },
    getPspHistorial(id, paginacion) {
        return axios.get(`/productos/psp/${id}/movimientos`, {
            params: { page: paginacion.page, page_size: paginacion.rowsPerPage },
        });
    },
    imprimirEtiquetasPsp(id, cantidad = 1) {
        return axios.get(`/productos/psp/${id}/etiquetas`, {
            params: { cantidad },
            responseType: 'blob',
        });
    },
    getPspPrecioSugerido(productoId, ppId) {
        return axios.get(`/productos/psp/precio-sugerido`, {
            params: { producto: productoId, pp: ppId },
        });
    },
    crearPsp(payload) {
        return axios.post(`/productos/psp`, payload);
    },
    configurarPspSucursal(payload) {
        return axios.post(`/productos/psp/configurar-sucursal`, payload);
    },
    getVianda() {
        return axios.get(`/productos/p?vianda=true`)
    },
    registrarProductosMedianteListaDePrecios(data) {
        var url = '/productos/registrar/productos-de-listadeprecio'
        return axios.post(url, data)
    },

    unificarProductos(data) {
        var url = `/productos/empresa/unificar`;
        return axios.post(url, data);
    },
    asignar(data) {
        return axios.post(`/productos/empresa/asignar`, data)
    },
    desasignar(data) {
        return axios.post(`/productos/empresa/desasignar`, data)
    },

}